import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';


const postFilterPreference = (userID, filterPreference, contextConfiguration) => {
	const token = getCookie('authToken');
	return axios.post(
		'/zoekopdrachten',
		{
			user: userID,
			...filterPreference
		},
		{
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			}
		}
	).catch(onRequestError);
};

export default postFilterPreference;
